export function download (data, name) {
  const link = document.createElement('a')
  document.body.append(link)
  link.href = data
  link.target = '_self'
  link.download = name
  link.click()
}
